import React from "react";
import * as Styled from "./styles";
import { useClinicalBudget } from "shared/providers/ClinicalBudget";
import { BudgetSummary } from "../../BudgetSummary";
import { IoArrowBack, IoArrowForward, IoReceipt } from "react-icons/io5";

const ClinicalBudgetConfig: React.FC = () => {
  const {
    setStep,
    totalItens,
    subtotal,
    total,
    desconto,
    descontoAutorizado,
    obsDesconto,
    parseMoeda,
    formatMoeda,
    showValues,
  } = useClinicalBudget();

  const handleBack = () => {
    setStep(1);
  };

  const handleContinue = () => {
    const descontoParsed = parseMoeda(desconto);
    
    // Validar motivo do desconto
    if (descontoAutorizado && descontoParsed > 0 && obsDesconto.trim() === '') {
      alert('Informe o motivo do desconto.');
      return;
    }

    setStep(3);
  };

  return (
    <Styled.Container>
      {/* Card de resumo rápido */}
      <Styled.InfoCard>
        <Styled.InfoHeader>
          <IoReceipt size={20} color="#3b82f6" />
          <h4>Resumo do Orçamento</h4>
        </Styled.InfoHeader>
        <Styled.InfoGrid>
          <Styled.InfoItem>
            <div className="label">Itens</div>
            <div className="value">{totalItens}</div>
          </Styled.InfoItem>
          {showValues && (
            <>
              <Styled.InfoItem>
                <div className="label">Sub-total</div>
                <div className="value">R$ {formatMoeda(subtotal)}</div>
              </Styled.InfoItem>
              <Styled.InfoItem>
                <div className="label">Desconto</div>
                <div className="value" style={{ color: '#ef4444' }}>{desconto}</div>
              </Styled.InfoItem>
              <Styled.InfoItem className="highlight">
                <div className="label">Total</div>
                <div className="value">R$ {formatMoeda(total)}</div>
              </Styled.InfoItem>
            </>
          )}
        </Styled.InfoGrid>
      </Styled.InfoCard>

      {/* Componente de resumo e configurações */}
      <BudgetSummary />

      {/* Botões fixos */}
      <Styled.BtnFixed>
        <Styled.Button variant="secondary" onClick={handleBack}>
          <IoArrowBack size={20} />
          Voltar
        </Styled.Button>
        <Styled.Button variant="primary" onClick={handleContinue}>
          Continuar
          <IoArrowForward size={20} />
        </Styled.Button>
      </Styled.BtnFixed>
    </Styled.Container>
  );
};

export { ClinicalBudgetConfig };

